import React from 'react';
import { Link } from 'react-router-dom';
import useScrollReveal from '../../hooks/useScrollReveal';

interface TrustBadge {
  icon: string;
  label: string;
}

const trustBadges: TrustBadge[] = [
  { icon: '🔒', label: 'Enterprise-grade security' },
  { icon: '✅', label: 'Audit-ready from day one' },
  { icon: '🌍', label: 'GDPR compliant \u00b7 EU data residency' },
];

export default function FinalCTA(): React.ReactElement {
  const ref = useScrollReveal();

  return (
    <section
      className="final-cta"
      id="final-cta"
      ref={ref as React.RefObject<HTMLElement>}
    >
      <div className="container">
        <h2 className="final-cta-headline reveal">
          Ready to see Actula in your environment?
        </h2>
        <p className="final-cta-sub reveal reveal-delay-1">
          We work with procurement, sustainability, and finance teams to configure Actula for your
          specific regulatory obligations, entity structure, and reporting timeline. Most clients are
          collecting structured data within two weeks of onboarding.
        </p>
        <div className="final-cta-buttons reveal reveal-delay-2">
          <Link to="/contact" className="btn btn-primary">Book a demo</Link>
          <Link to="/contact" className="btn btn-ghost-light">Talk to us about your framework</Link>
        </div>
        <div className="final-cta-badges reveal reveal-delay-3">
          {trustBadges.map((b, i) => (
            <div key={i} className="trust-badge">
              <span className="trust-badge-icon">{b.icon}</span>
              {b.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
